// removed by extract-text-webpack-plugin
module.exports = {"Button":"LinkIcon__Button__1OUJL","Success":"LinkIcon__Success__37iVV","Danger":"LinkIcon__Danger__igPMw","Neutral":"LinkIcon__Neutral__tqniS","Small":"LinkIcon__Small__Jk1XW","ButtonText":"LinkIcon__ButtonText__2oKw6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/LinkIcon/LinkIcon.css
// module id = 334
// module chunks = 0